import type { QuestionBoxHandle } from "@ui/organisms/QuestionBox/QuestionBox";
import { Show } from "solid-js";
import { ClipboardView } from "~/modules/shared/chat/components/clipboard/ClipboardView";
import { clipboardQuestionBoxMentions } from "~/modules/shared/chat/components/clipboard/clipboardMentions";
import { clipboardIsEmpty } from "~/modules/shared/chat/components/clipboard/clipboardStore";
import "./AskPageClipboard.css";

type Props = {
	/** The follow-up composer the clips can be pasted into, when there is one. */
	followUp?: QuestionBoxHandle;
	canAddToBoard: boolean;
};

/**
 * The clips collected from a thread. The follow-up composer isn't pinned the
 * way the studio's reply box is, so the clipboard pins itself instead: a clip
 * added from high up a long thread would otherwise land out of sight.
 */
export const AskPageClipboard = (props: Props) => (
	<Show when={!clipboardIsEmpty()}>
		<div class="ask-page-clipboard">
			<ClipboardView
				onPasteContext={
					props.followUp
						? () =>
								props.followUp?.insertVideoMentions(
									clipboardQuestionBoxMentions(),
								)
						: undefined
				}
				canAddToBoard={props.canAddToBoard}
			/>
		</div>
	</Show>
);
